import { render, staticRenderFns } from "./ProductionNewsFeed.vue?vue&type=template&id=3aeb8cf6&scoped=true&"
import script from "./ProductionNewsFeed.vue?vue&type=script&lang=js&"
export * from "./ProductionNewsFeed.vue?vue&type=script&lang=js&"
import style0 from "./ProductionNewsFeed.vue?vue&type=style&index=0&id=3aeb8cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeb8cf6",
  null
  
)

export default component.exports